export type AsNumeralInterface = {
  changeLocal: (newLocale: string) => void;
  formatAsCurrency: (value: number) => string;
};
